import { Download } from '@mui/icons-material';
import { Box, Table, TableCell, TableRow, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { FSCard } from '@/ui/components/FSCard';
import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';

export function FileExampleView({
  onClickDownloadCsvTemplate,
}: {
  onClickDownloadCsvTemplate: () => void;
}) {
  const borderColor = ColorsRaw.secondary.Light_Purple;
  const headers = [
    '✅ Date',
    '✅ Nom',
    '✅ Lieu',
    '✅ Fréquentation',
    '✅ Type',
  ];
  const rows = [
    [
      getNextSaturday().format('DD/MM/YYYY'),
      'Zénith Paris',
      'Zenith Paris',
      '4500',
      'Salle',
    ],
    [
      getNextSaturday().add(7, 'day').format('DD/MM/YYYY'),
      'Art Rock',
      'saint brieuc',
      '8000',
      'Festival',
    ],
  ];
  return (
    <FSCard
      variant="elevation"
      sx={{ bgcolor: ColorsRaw.anthracite.Warm_Anthracite_2 }}
    >
      <Box sx={{ textAlign: 'center', mt: 2 }}>
        <Typography sx={{ fontSize: '1rem', fontWeight: 700 }}>
          {translate(
            'ProjectsTour.OnTour.ModalImportCsv.file-example-description',
          )}
        </Typography>
      </Box>
      <Box
        sx={{
          overflow: 'hidden',
          maskImage: 'linear-gradient(to bottom, black 20%, transparent 100%)',
          WebkitMaskImage:
            'linear-gradient(to bottom, black 20%, transparent 100%)',
        }}
      >
        <Box
          sx={{
            mx: 4,
            my: 2,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Table sx={{ width: 'auto' }}>
            <TableRow>
              {headers.map((header) => (
                <TableCell
                  key={header}
                  sx={{
                    border: `1px solid ${borderColor}`,
                    fontSize: '0.875rem',
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
            {rows.map((row) => (
              <TableRow key={row[0]}>
                {row.map((cell) => (
                  <TableCell
                    key={cell}
                    sx={{
                      border: `1px solid ${borderColor}`,
                      fontSize: '0.875rem',
                    }}
                  >
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </Table>
        </Box>
      </Box>
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <FSPrimaryButton
          variant="outlined"
          color="primary"
          startIcon={<Download />}
          onClick={onClickDownloadCsvTemplate}
        >
          {translate(
            'ProjectsTour.OnTour.ModalImportCsv.download-csv-template',
          )}
        </FSPrimaryButton>
      </Box>
    </FSCard>
  );
}

function getNextSaturday(date = dayjs()) {
  const days = (6 - date.day() + 7) % 7 || 7;
  return date.add(days, 'day');
}
